import { useState } from "react";
import { isEmpty } from "../../utilities/isEmpty";
import axios from "axios";
import {
  parseAddToCartResponse,
  triggerFragmentRefresh,
} from "../../modules/ajaxAddToCart";
import { nanoid } from "nanoid/non-secure";
import clsx from "clsx";
import { GA4AddToCart } from "../../lib/tracking";

const AddToBagButton = ({
  hasSize,
  hasAmount,
  isGiftCardProduct,
  isPassepartoutProduct,
  isFrameProduct,
  isCanvasProduct,
  selectedAmountVariant,
  selectedSizeVariant,
  selectedPassepartoutVariant,
  selectedFrameVariant,
  isOutOfStock,
}) => {
  const [buttonLabel, setButtonLabel] = useState("Add to bag");

  const hasSelectedFrameForCanvas = Boolean(
    selectedFrameVariant?.id && selectedFrameVariant?.slug !== "no-frame",
  );

  const trackAddToCart = ({ products }) => {
    const name = singleProductName;
    const artist = singleProductArtist;
    const currency = "EUR";
    let category = "Posters";
    const isRegularProduct =
      !isFrameProduct && !isPassepartoutProduct && !isGiftCardProduct;
    if (isFrameProduct) {
      category = "Frames";
    } else if (isPassepartoutProduct) {
      category = "Passepartouts";
    } else if (isGiftCardProduct) {
      category = "Giftcard";
    }

    const items = products.map((p, i) => {
      const item = {
        id: p.id,
        category,
        currency,
        quantity: 1,
        size: p.size,
        listName: "SPP",
        price: p.price,
      };
      if (i === 0) {
        item.name = name;
        item.artist = isRegularProduct ? artist?.[0]?.name : "";
        item.category = category;
      }
      return item;
    });

    GA4AddToCart({ items });
  };

  const typeMapper = (type) => {
    switch (type) {
      case "amount":
        return "g";
      case "size":
        return "p";
      case "passepartout":
        return "ppt";
      case "frame":
        return "f";

      default:
        return "";
    }
  };

  const addToBag = async () => {
    if (isOutOfStock) return;

    // if (isCanvasProduct && !hasSelectedFrameForCanvas) {
    //   setButtonLabel("Please select a frame");
    //   setTimeout(() => {
    //     setButtonLabel("Add to bag");
    //   }, 2500);
    //   return;
    // }

    if (!hasSize && !hasAmount) {
      // console.log("otlolo");
      if (isGiftCardProduct) {
        setButtonLabel("Please select an amount");
      } else if (isFrameProduct) {
        setButtonLabel("Please select a size");
      } else if (isPassepartoutProduct) {
        setButtonLabel("Please select a size");
      } else {
        setButtonLabel("Please select a size");
      }

      setTimeout(() => {
        setButtonLabel("Add to bag");
      }, 2500);

      return;
    }

    setButtonLabel("Adding");

    const products = [
      ...(!isEmpty(selectedAmountVariant) ? [selectedAmountVariant] : []),
      ...(!isEmpty(selectedSizeVariant) ? [selectedSizeVariant] : []),
      ...(!isEmpty(selectedPassepartoutVariant)
        ? [selectedPassepartoutVariant]
        : []),
      ...(!isEmpty(selectedFrameVariant) ? [selectedFrameVariant] : []),
    ].filter(({ id }) => id);

    console.log("products", products);

    const uuid = nanoid();

    const productsReadyForBag = products.map(({ id }) => `${id}:1:${uuid}`);

    console.log("productsReadyForBag", productsReadyForBag);

    try {
      const params = new URLSearchParams();
      params.append(
        "addToCart",
        encodeURIComponent(productsReadyForBag.join(",")),
      );
      params.append("tpcSource", "spp");

      console.log(
        'encodeURIComponent(productsReadyForBag.join(","))',
        encodeURIComponent(productsReadyForBag.join(",")),
      );

      console.log("the params", params);

      const { data, status } = await axios({
        method: "post",
        url: window.location.origin,
        data: params,
      });

      if (status === 200) {
        const { msg, info, error } = parseAddToCartResponse({ data });
        triggerFragmentRefresh();

        setButtonLabel(
          `${productsReadyForBag.length === 1 ? "Product" : "Products"} added to bag`,
        );

        setTimeout(() => {
          setButtonLabel("Add to bag");
        }, 2500);
        trackAddToCart({ products });
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const isButtonDisabled =
    isOutOfStock || (isCanvasProduct && !hasSelectedFrameForCanvas);

  return (
    <>
      <button
        className={clsx(
          "font-normal font-display-bold text-sm tracking-wider text-white uppercase w-full h-11 flex justify-center items-center transition-colors duration-200 ease-in-out mt-4",
          isButtonDisabled ? "bg-[#787878]" : "bg-black",
        )}
        onClick={() => addToBag()}
        disabled={isButtonDisabled}
      >
        {isOutOfStock
          ? isWallObjectsProduct || isLimitedEditionsProduct
            ? "Sold out"
            : "Out of stock"
          : buttonLabel}
      </button>
    </>
  );
};

export default AddToBagButton;
